<template>
  <div class="row">
    <div class="col-3 px-2">
      <label for="top" class="d-block text-center">
        <b-img src="@/assets/images/coat-hanger-box/coat-hanger-opening-top.png" fluid alt="dall'alto"></b-img>
        <b-form-radio id="top" v-model="vModel" name="boxOpenings" :value="COAT_HANGER_BOX_OPENINGS.TOP"></b-form-radio>
        <small>{{ $t('props.boxOpenings.top') }}</small>
      </label>
    </div>
    <div class="col-3 px-2">
      <label for="diagonal" class="d-block text-center">
        <b-img src="@/assets/images/coat-hanger-box/coat-hanger-opening-diagonal.png" fluid alt="diagonale"></b-img>
        <b-form-radio id="diagonal" v-model="vModel" name="boxOpenings" :value="COAT_HANGER_BOX_OPENINGS.DIAGONAL"></b-form-radio>
        <small>{{ $t('props.boxOpenings.diagonal') }}</small>
      </label>
    </div>
    <div class="col-3 px-2">
      <label for="horizontal" class="d-block text-center">
        <b-img src="@/assets/images/coat-hanger-box/coat-hanger-opening-horizontal.png" fluid alt="tre onde"></b-img>
        <b-form-radio id="horizontal" v-model="vModel" name="boxOpenings" :value="COAT_HANGER_BOX_OPENINGS.HORIZONTAL"></b-form-radio>
        <small>{{ $t('props.boxOpenings.horizontal') }}</small>
      </label>
    </div>
    <div class="col-3 px-2">
      <label for="frontal" class="d-block text-center">
        <b-img src="@/assets/images/coat-hanger-box/coat-hanger-opening-front.png" fluid alt="frontale"></b-img>
        <b-form-radio id="frontal" v-model="vModel" name="boxOpenings" :value="COAT_HANGER_BOX_OPENINGS.FRONTAL"></b-form-radio>
        <small>{{ $t('props.boxOpenings.frontal') }}</small>
      </label>
    </div>
  </div>
</template>
<script>
import { InputField } from '../Input.mixin'
import { COAT_HANGER_BOX_OPENINGS } from '../../../utils/products.enums'

export default {
  name: 'InputCoatHangerBoxOpening',
  extends: InputField,
  data () {
    return {
      COAT_HANGER_BOX_OPENINGS
    }
  }
}
</script>
